
/*
import { Component, OnInit, Input } from '@angular/core';
import { UserService } from '../user.service';
import { User } from '../models/users.model';

import { Router } from '@angular/router';

import { ChartsComponent } from '../charts/charts.component';

*/


import {
  Component,
  OnInit,
  ElementRef,
  ChangeDetectorRef,
  Input
} from '@angular/core';
import { Router } from '@angular/router';

import { UserService } from '../user.service';

import { User } from '../models/users.model';


@Component({
  selector: 'course-enroll-pane',
  templateUrl: './course-enroll-pane.component.html'
})

export class CourseEnrollPaneComponent implements OnInit {

  @Input() page: number;

  user: User;

constructor(
  private userService: UserService,
  private router: Router,
  private elementRef: ElementRef,
  private changeDetectorRef: ChangeDetectorRef,
) {}

  ngOnInit() {
  }

  aws_op_dashboard() {
    this.router.navigate(['/course/awsop/dashboard']);
  }
}



// WEBPACK FOOTER //
// ./src/app/course-enroll-pane/course-enroll-pane.component.ts